import { DiffModel } from '../../../models/diffModel';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import DiffViewer from 'react-diff-viewer';
import React from 'react';

interface Props {
  readonly diffModel?: DiffModel;
}

const SideBySideDiffView = (props: Props) => {
  const { diffModel } = props;

  if (!diffModel || diffModel.diffs.length === 0) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity='info'>No changes</Alert>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>

      {diffModel.diffs.map(({ prev, next }, index) => (
        <Grid item xs={12} key={index} >
          <DiffViewer
            oldValue={prev?.configFile.content}
            newValue={next?.configFile.content}
            splitView={true}
            leftTitle={prev?.configFile.filename}
            rightTitle={next?.configFile.filename}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default SideBySideDiffView;
